import React, { useState, useEffect } from "react";
import Header from "../component/Header";
import CommonBanner from "../component/CommonBanner";
import Footer from "../component/Footer";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Form,
  Dropdown,
} from "react-bootstrap";
import Like from "../assets/images/like.svg";
import Img1 from "../assets/images/buy/img-1.png";
import Img2 from "../assets/images/buy/img-2.png";
import Img3 from "../assets/images/buy/img-3.png";
import Img4 from "../assets/images/buy/img-4.png";
import Img5 from "../assets/images/buy/img-5.png";
import bed from "../assets/images/bed.svg";
import bath from "../assets/images/bath.svg";
import size from "../assets/images/scale.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import { GET_SAVED_PROPERTIES } from "../api/constants";
import power from '../assets/images/power.svg'
import storey from '../assets/images/storey.svg'
import { formatRentalPeriod } from "../utils/formatRentalPeriod";
import { Link } from "react-router-dom";
import useFavoritesList from "../hooks/useFavoritesList";



function SavedHomes() {
    const { isFavorite, toggleFavorite } = useFavoritesList();
  
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await fetch(GET_SAVED_PROPERTIES, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const result = await response.json();

        console.log("Fetched from API:", result.data);

        if (result?.status && Array.isArray(result.data)) {
          setProperties([...result.data]); // ✅ new array reference
        } else {
          setProperties([]);
        }
      } catch (err) {
        console.error(err);
        setProperties([]);
      }
    };

    fetchProperties();
  }, []);

  useEffect(() => {
    console.log("Updated state:", properties); // ✅ should show data now
  }, [properties]);


  const [favorites, setFavorites] = useState(() => new Set());
  const [compareList, setCompareList] = useState([]);



  const handleCompareChange = (item) => {
    setCompareList((prev) => {
      const exists = prev.find((p) => p.id === item.id);

      if (exists) {
        return prev.filter((p) => p.id !== item.id);
      } else {
        const newList = [...prev, item];
        return newList;
      }
    });
  };

  const handleCompareClick = () => {
    if (compareList.length >= 2) {
      navigate("/compare-homes");
    }
  };
  const isInCompareList = (id) => {
    return compareList.some((item) => item.id === id);
  };
  const [showHomeTypeDropdown, setShowHomeTypeDropdown] = useState(false);
  const [selectedHomeTypes, setSelectedHomeTypes] = useState([]);
  // Home type
  const homeTypes = ["For Sale", "For Rent"];

  const applyHomeTypeFilter = () => {
    setShowHomeTypeDropdown(false);
  };

  const toggleHomeType = (type) => {
    setSelectedHomeTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };
  const [sort, setSort] = useState("By date added");
  return (
    <>
      <div className="main saved-homes-page">
        <Header />
        <CommonBanner title="Saved Homes" />
        <section className="saved-homes-section common-padding">
          <Container>
            <div className="result-view">
              <div>
                <h2>Saved Properties ({properties.length})</h2>
              </div>
              <div className="d-flex align-content-center gap-4">
                <Dropdown
                  show={showHomeTypeDropdown}
                  onToggle={(open) => setShowHomeTypeDropdown(open)}
                  align="end"
                >
                  <Dropdown.Toggle id="home-type-dropdown">
                    Showing All
                  </Dropdown.Toggle>

                  <Dropdown.Menu as="div" className="home-type-dropdown custom-dm">
                    <div className="home-type-options">
                      {homeTypes.map((type) => (
                        <Form.Check
                          key={type}
                          type="checkbox"
                          id={`home-type-${type}`}
                          label={type}
                          className="custom-checkbox primary"
                          onChange={() => {
                            toggleHomeType(type);
                          }}
                          checked={selectedHomeTypes.includes(type)}
                        />
                      ))}
                      <Button
                        className="custom-bttn w-100 mt-3"
                        onClick={applyHomeTypeFilter}
                      >
                        Apply
                      </Button>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown align="end" onSelect={(key) => key && setSort(key)}>
                  <Dropdown.Toggle id="sort-dropdown">
                    {sort === "Sort by" ? <>By date added</> : <>{sort}</>}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {[
                      "Date Added",
                      "Status",
                      "Price",
                      "Bedrooms",
                      "Bathrooms",
                      "Home size (sq. ft.)",
                      "Lot size (sq. ft.)",
                    ].map((opt) => (
                      <Dropdown.Item
                        key={opt}
                        eventKey={opt}
                        active={sort === opt}
                      >
                        {opt}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            {compareList.length >= 2 && (
              <div className="compare-counter-bar">
                <Button
                  className="custom-bttn style-3"
                  onClick={handleCompareClick}
                >
                  Compare Now
                </Button>
              </div>
            )}
            <Row className="row-gap-4">
              {properties.map((item) => (

                <Col md={6} lg={4} key={item.id} to={item.listing_type === "rent" && item.property_type === "residential" ? `/rent-details/${item.id}` : item.property_type === "commercial" ? `/commercial-details/${item.id}` : `/buy-details/${item.id}`}>
                  <Link to={item.listing_type === "rent" && item.property_type === "residential" ? `/rent-details/${item.id}` : item.property_type === "commercial" ? `/commercial-details/${item.id}` : `/buy-details/${item.id}`}>

                    {/* <Col md={6} lg={4} key={item.id}> */}
                    <div className="property-box">
                      {/* <div className="compare-checkbox-wrapper">
                        <Form.Check
                          type="checkbox"
                          id={`compare-${item.id}`}
                          label="Compare"
                          checked={isInCompareList(item.id)}
                          onChange={() => handleCompareChange(item)}
                          className="custom-checkbox primary"
                        />
                      </div> */}
                      <div className="result-item-img position-relative">
                        <Swiper
                          modules={[Autoplay, Pagination]}
                          spaceBetween={20}
                          centeredSlides={true}
                          slidesPerGroup={1}
                          // loop={true}
                          // autoplay={{ delay: 2500, disableOnInteraction: false }}
                          pagination={{ clickable: true }}
                        >
                          {item.images.length > 0 &&
                            item.images.slice(0, 3).map((url, idx) => (
                              <SwiperSlide key={idx}>
                                <Card className="border-0">
                                  <Card.Img src={url.image} />
                                </Card>
                              </SwiperSlide>
                            ))
                          }
                        </Swiper>

                        {item.tag && (
                          <span className="recommended">{item.tag}</span>
                        )}

                         <span
                        key={item.id}
                        role="button"
                        tabIndex={0}
                        className={`wishlist ${isFavorite(item.id) ? "active" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleFavorite(item.id);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") toggleFavorite(item.id);
                        }}
                      >

                        <img
                          src={Like}
                          alt="like"
                        />
                      </span>
                      </div>
                      <div className="result-item-info">
                        {item.listing_type === "rent" ? (
                          <h2>KES{item.price}
                            <span className="rental-period">
                              {formatRentalPeriod(item.rental_term)}
                            </span></h2>

                        ) :
                          <h2>KES{item.price}</h2>}

                        <p>{item.street_address}</p>
                        <div className="info-box">
                          {item.property_type === "residential" ? (
                            <>
                              <span>
                                <img src={bed} alt="" /> {item.details?.bedrooms ?? 0}
                              </span>
                              <span>
                                <img src={bath} alt="" /> {item.details?.bathrooms ?? 0}
                              </span>
                            </>
                          ) : (
                            <>
                              <span>
                                <img src={storey} alt="" /> {item.details?.floor_count}
                              </span>
                              <span>
                                <img src={power} alt="" /> {item.details?.power_capacity_kva}
                              </span>
                            </>
                          )}


                          <span>
                            <img src={size} alt="" /> {item.size_sqft}
                          </span>
                        </div>
                        {item.showButton ? (
                          <Button className="custom-bttn style-2 w-100 mt-3">
                            Request a tour
                          </Button>
                        ) : (
                          <h6>Listing by : <span>{item.listing_by?.name}</span></h6>)}
                      </div>
                    </div>
                  </Link>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </>
  );
}
export default SavedHomes;
